import $ajax from 'axios'
// import {Message} from 'element-ui'
import { hideLoad } from '@/tools/loading.js'
import msgWarning from '@/tools/msgwarning.js'
import api from '@/utils/api.js'
/*
  得到地点 get /cms/GetPlaces
  keyword     str 关键字
  parentCode  int 上级地点code 中国为：100000，北京为：110000，北京市为：110100
  level       int 地点级别 1省 2市 3区
*/
export function getPlaces(parentCode, fn) {
  $ajax.get('v2/cms/GetPlaces', {
    params: {
      parentCode
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
//通过经纬度获取城市名
export const getCityName = async (lng, lat) => {
  try {
    let res = await api(`v2/cms/GetCoordinateCityInfo?lng=${lng}&lat=${lat}`)
    return res
  } catch (e) {
    console.error(e)
  }
}
export function getPlaces2(keyword, fn) {
  $ajax.get('v2/cms/GetPlaces', {
    params: {
      keyword
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  根据坐标得到区码 get /cms/GetCoordinateDistrictCode
  lng num 经度
  lat num 纬度
*/
export function getCoordinateDistrictCode(lng, lat, fn) {
  $ajax.get('v2/cms/GetCoordinateDistrictCode', {
    params: {
      lng,
      lat
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  得到第三方配送等待时间 get /cms/GetConfig
  key str
*/
export function getConfig(key, fn) {
  $ajax.get('v2/cms/GetConfig', {
    params: {
      key
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  设置配置参数 put /cms/SetConfig
  key str
  value str
*/
export function setConfig(key, value, fn) {
  $ajax.put(`v2/cms/SetConfig?key=${key}&value=${value}`).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  从UPC码得到商品信息 get /cms/GetProductInfoByBarCode
  barCode str
*/
export function getInfoByBarcode(barCode, fn) {
  $ajax.get('v2/cms/GetProductInfoByBarCode', {
    params: {
      barCode
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

// export {getPlaces, getCoordinateDistrictCode, getPlaces2, getConfig, setConfig, getInfoByBarcode}

/*
  type str 配置类型，当前支持 PricePack, Bank
  key str 配置名
  keyword str 关键字
*/
export const queryConfigs = async (json = {}) => {
  try {
    let { noLoading = false, type = 'PricePack', key, keyword } = json
    let params = {
      type
    }
    if (key) params.key = key
    if (keyword) params.keyword = keyword
    let res = await api('v2/cms/QueryConfigs', {
      params,
      noLoading
    })
    if (res) {
      if (type === 'Bank') {
        // 银行
        return res
      } else {
        // 调价包
        return res.map(item => ({
          ...item,
          value: JSON.parse(item.value)
        }))
      }
    } else {
      return []
    }
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}
// 查询会员配置
export const queryVipConfigs = async () => {
  try {
    let params = { type: 'DiscountCard', key: '会员折扣卡' }
    let noLoading = false
    let res = await api('v2/cms/QueryConfigs', {
      params,
      noLoading
    })
    if (res) {
      return res
    } else {
      return []
    }
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}

export const updateStoreTemplate = async (json = {}) => {
  try {
    let { noLoading = false, storeID , content, sound } = json
    let form = new FormData()
    form.append('storeID', storeID)
    form.append('content', content)
    form.append('sound', sound)
    let res = await api('v2/store/UpdateStoreTemplate', {
      method: 'POST',
      data: form,
      noLoading
    })
    return res
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}

/*
  ## 新增配置 POST(FormData) /cms/NewConfig
  type str 配置类型，当前只支持 PricePack
  key str 配置名
  value str 配置值 []
*/
export const newConfig = async (json = {}) => {
  try {
    let { noLoading = false, type = 'PricePack', key, value } = json
    let form = new FormData()
    form.append('type', type)
    form.append('key', key)
    form.append('value', value)
    let res = await api('v2/cms/NewConfig', {
      method: 'POST',
      data: form,
      noLoading
    })
    return res
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}

/*
  ## 删除配置 DELETE(query) /cms/DeleteConfig
  type str 配置类型，当前只支持 PricePack
  key str 配置名
*/
export const deleteConfig = async (json = {}) => {
  try {
    let { noLoading, type = 'PricePack', key } = json
    let params = {
      type,
      key
    }
    let res = await api('v2/cms/DeleteConfig', {
      method: 'DELETE',
      params,
      noLoading
    })
    return res
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}

/*
  ## 修改配置 PUT(formData) /cms/UpdateConfig
  type str 配置类型，当前只支持 PricePack
  key str 配置名
  value str 配置值
*/
export const updateConfig = async (json = {}) => {
  try {
    let { noLoading, type = 'PricePack', key, value } = json
    let form = new FormData()
    form.append('type', type)
    form.append('key', key)
    form.append('value', value)
    let res = await api('v2/cms/UpdateConfig', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: form,
      noLoading
    })
    return res
  } catch (e) {
    msgWarning(e)
    return -1
  } finally {
    hideLoad()
  }
}

// 获取平台账号信息
export const getVendorOrgCodeInfo = async () => {
  try {
    let res = await api('v2/cms/GetVendorOrgCodeInfo')
    return res
  } catch (e) {
    throw e
  }
}

// 新接口 获取平台账号信息 vendorType=platform 查平台账号   vendorID 0 京东
export const newCetVendorOrgCodeInfo = async (vendorID=-1,) => {
  try {
    let res = await api('v2/sys/GetVendorOrgCode',{
      params:{
        vendorType:'platform',
        vendorID,
      },
      noLoading:true,
    })
    return res
  } catch (e) {
    throw e
  }
}

// 新接口 修改平台账号信息 vendorType=platform 查平台账号   vendorID 0 京东
export const updateVendorOrgCode = async (id,json) => {
  let form = new FormData()
  form.append('id', id)
  form.append('payload', JSON.stringify(json))
  try {
    let res = await api('v2/sys/UpdateVendorOrgCode',{
      method:'POST',
      data:form,
      noLoading:true,
    })
    return res
  } catch (e) {
    throw e
  }
}

export const addVendorOrgCode = async (json) => {
  let form = new FormData()
  form.append('payload', JSON.stringify(json))
  try {
    let res = await api('v2/sys/AddVendorOrgCode',{
      method:'POST',
      data:form,
      noLoading:true,
    })
    return res
  } catch (e) {
    throw e
  }
}

export const getDayVercabulary = async (offset,pageSize,noLoading = true) => {
  try {
    let res = await api(`v2/know/GetMaterialList?offset=${offset}&pageSize=${pageSize}`, { noLoading })
    return res
  } catch (e) {
    throw e
  }
}
export const getDayArticle = async (offset,pageSize,noLoading = true) => {
  try {
    let res = await api(`v2/know/GetKnowledgeDepot?offset=${offset}&pageSize=${pageSize}`, { noLoading })
    return res
  } catch (e) {
    throw e
  }
}


// WEBPACK FOOTER //
// ./src/apis/cms.js